module.exports = __webpack_public_path__ + "media/src/images/zu_teaching01_page8-680a086ed53e3b70c8be8568bf72b30d.gif";